/**
 * UsersPageHeader - Header section for the users management page.
 *
 * Displays page title, description, and the "Add User" button.
 */

import { Plus } from 'lucide-react';
import { Button } from '@lean-agility/design-system/react';

export interface UsersPageHeaderProps {
  /**
   * Callback when "Add User" button is clicked.
   */
  onAddUser: () => void;
}

export function UsersPageHeader({ onAddUser }: UsersPageHeaderProps) {
  return (
    <div className="mb-6 flex min-w-150 items-center justify-between">
      <div>
        <h1
          className="
            text-3xl font-bold text-text-primary
            dark:text-text-primary
          "
        >
          User Management
        </h1>
        <p
          className="
            mt-1 text-sm text-text-muted
            dark:text-text-muted
          "
        >
          Manage user accounts and permissions
        </p>
      </div>
      <Button onClick={onAddUser}>
        <Plus className="size-4" />
        Add User
      </Button>
    </div>
  );
}
